import React from 'react';
import PropTypes from 'prop-types';
import Details from '@eg/elements/Details';
import { SvgAuszahlung } from '../../../helpers/IconLoader';
import { legalConsentProps } from '../../../models/panels';
import { getPayingOutData } from '../../../helpers/formData/vehicleFormData';

const PayingOutDetails = ({ formData, localePath, className }, { t }) => {
  const {
    isLiabilityFlow,
    isWholeCarTheftFlow,
    recommendRepairShop,
    bankAccount,
    ibanName,
    iban,
    invoices,
    repairShopName,
    workshopAddress,
    workshopCity,
    workshopPhone,
  } = getPayingOutData(formData);

  return (
    <>
      {!isWholeCarTheftFlow
        && !recommendRepairShop
        && (bankAccount || (isLiabilityFlow && ibanName))
        && (
          <Details iconLeft={SvgAuszahlung} summary={t(`${localePath}.paying-out.title`)} className={className}>
            {(bankAccount || (isLiabilityFlow && ibanName)) && (
              t(`${localePath}.paying-out.content`, {
                account: iban
                  ? t(`${localePath}.paying-out.account-details`, {
                    ibanName,
                    iban,
                  }) : t(`${localePath}.paying-out.another-account`),
              })
            )}
            {invoices && (t(`${localePath}.paying-out.invoices`))}
            {repairShopName && (
              t(`${localePath}.paying-out.workshop`, {
                repairShopName,
                address: workshopAddress ? t(`${localePath}.paying-out.address`, { workshopAddress }) : '',
                city: workshopCity ? t(`${localePath}.paying-out.city`, { workshopCity }) : '',
                phone: workshopPhone ? t(`${localePath}.paying-out.phone`, { workshopPhone }) : '',
              })
            )}
          </Details>
        )}
    </>
  );
};

PayingOutDetails.propTypes = legalConsentProps.sectionProps;
PayingOutDetails.defaultProps = legalConsentProps.sectionDefaults;

PayingOutDetails.contextTypes = {
  t: PropTypes.func,
};

export default PayingOutDetails;
